/**
 * KAN-737: per-stage cohort stats of a funnel block for one period and channel.
 * KAN-744: the source is a parameter (org-wide funnel or a manager's funnel).
 */
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import type {
  FunnelStageStatsResponse,
  FunnelStatsChannel,
  FunnelStatsPeriod,
} from '@/types/funnel'

export type FunnelStageStatsLoader = (
  period: FunnelStatsPeriod,
  channel: FunnelStatsChannel,
) => Promise<FunnelStageStatsResponse>

export function useFunnelStageStats(
  queryKey: readonly unknown[],
  load: FunnelStageStatsLoader,
  period: FunnelStatsPeriod,
  channel: FunnelStatsChannel,
) {
  return useQuery<FunnelStageStatsResponse>({
    queryKey: [...queryKey, period, channel],
    queryFn: () => load(period, channel),
    placeholderData: keepPreviousData,
    staleTime: 60_000,
  })
}
